// Shared instrument-panel parts: lamps, soft keys, switches, segmented control, strength ticks.
import { h, type Child } from "./dom";

export type Tone = "cyan" | "green" | "amber" | "red" | "magenta";

export function lamp(label: string, lit: boolean, tone: Tone = "green", title?: string): HTMLElement {
  return h("span", { class: `lamp ${lit ? "lit " + tone : "unlit"}`, title }, label);
}

export interface KeyOpts {
  on?: boolean;
  danger?: boolean;
  primary?: boolean;
  disabled?: boolean;
  title?: string;
  sm?: boolean;
  cls?: string;
}
/** A soft key. */
export function key(label: string, onClick: (e: MouseEvent) => void, o: KeyOpts = {}): HTMLButtonElement {
  const cls = ["btn", o.on && "on", o.danger && "danger", o.primary && "primary", o.sm && "sm", o.cls].filter(Boolean).join(" ");
  const b = h("button", { class: cls, type: "button", title: o.title, disabled: o.disabled, "aria-pressed": o.on === undefined ? undefined : String(!!o.on) }, label);
  b.addEventListener("click", onClick);
  return b;
}

export function sw(label: string, on: boolean, onChange: (v: boolean) => void, red = false): HTMLElement {
  const input = h("input", { type: "checkbox", checked: on });
  input.addEventListener("change", () => onChange(input.checked));
  return h("label", { class: "sw" + (red ? " red" : "") }, input, h("span", { class: "trk" }), h("span", { class: "lb" }, label));
}

export function seg<T extends string>(opts: { value: T; label: string }[], value: T, onChange: (v: T) => void, cls = ""): HTMLElement {
  const el = h("div", { class: "seg " + cls, role: "group" });
  for (const o of opts) {
    const b = h("button", { type: "button", class: o.value === value ? "on" : "", "aria-pressed": String(o.value === value) }, o.label);
    b.addEventListener("click", () => onChange(o.value));
    el.appendChild(b);
  }
  return el;
}

export function ticks(n: number): HTMLElement {
  const el = h("span", { class: "ticks", title: `Strength ${n} of 5`, "aria-label": `Strength ${n} of 5` });
  for (let i = 1; i <= 5; i++) el.appendChild(h("i", { class: i <= n ? "f" : "" }));
  return el;
}

export function field(label: string, control: HTMLElement, cls = ""): HTMLElement {
  return h("label", { class: "f " + cls }, h("span", { class: "micro" }, label), control);
}

export function panel(title: string, body: Child, right?: HTMLElement | null, cls = ""): HTMLElement {
  return h("section", { class: "panel " + cls }, h("div", { class: "ph" }, h("span", { class: "ttl" }, title), h("span", { class: "grow" }), right ?? null), body);
}

export function emptyState(onGo: () => void): HTMLElement {
  return h(
    "div",
    { class: "empty" },
    h("div", { class: "t" }, "NO DATA LOADED. Drop your Monday export, Google Contacts and LinkedIn files on SOURCES."),
    key("GO TO SOURCES", onGo, { primary: true }),
  );
}
